import CustomTable from '../../../../shared/components/CustomTable';
import { addOnColumns } from './columns';
import { EMPTY_COPY } from '../../constants';
import type { ClientAddOn } from '../../../../types/ClientManagementTypes';
import styles from './ClientTables.module.scss';

interface AddOnsTableProps {
  addOns: ClientAddOn[];
  onSelect: () => void;
}

/** Inset table for one expanded client row; sized by the client table around it. */
const AddOnsTable = ({ addOns, onSelect }: AddOnsTableProps) => (
  <CustomTable<ClientAddOn>
    className={styles.addOnsTable}
    rowKey="id"
    dataSource={addOns}
    columns={addOnColumns}
    pagination={false}
    tableLayout="fixed"
    onRow={() => ({ onClick: onSelect })}
    locale={{ emptyText: <p className={styles.addOnsEmptyState}>{EMPTY_COPY.NO_ADD_ONS}</p> }}
  />
);

export default AddOnsTable;
